import { RegisterWarranty } from "src/Components/Pumkin/RegiterWarranty";

export const PageRegisterWarranty = () => {
    return <RegisterWarranty />;
};
